export default __webpack_public_path__ + "static/media/logoBorde.e5cdb68e.png";